import React from "react";

const DestinationSection = () => {
  return (
    <section
      className="vs-destination-style1 bg-third-theme-12 overflow-hidden space py-4"
      data-bg-src="/img/bg/about-trip-bg.png"
    >
      <img
        className="des-icon-1 animate-parachute"
        src="/img/icons/destination-icon-1.png"
        alt="icon"
      />
      <img
        className="des-icon-2 animate-tree"
        src="/img/icons/destination-icon-2.png"
        alt="icon"
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle fade-anim" data-direction="bottom">
                Top Routes
              </span>
              <h2 className="sec-title fade-anim" data-direction="top">
                Ride with Comfort <br />
                Trusted Travel by Mauli Cabs
              </h2>
            </div>
          </div>
        </div>
        <div className="row g-4">
        
          <div
            className="col-md-6 col-xl-4 fade-anim"
            data-delay="0.45"
            data-direction="left"
          >
            <div className="destination-box style-2">
              <div className="destination-thumb">
                <img
                  src="/images/1.jpg"
                  alt="Mumbai to Pune"
                  className="w-100"
                />
              </div>
              <div className="destination-content">
                <div className="info">
                  <h4 className="text-white text-capitalize">
                    <a href="#">Mumbai to Pune</a>
                  </h4>
                  <span className="text-theme-color d-block">Airport Pickup & Drop</span>
                </div>
                <a href="#" className="icon bg-theme-color text-white-color">
                  <i className="fa-solid fa-location-dot"></i>
                </a>
              </div>
            </div>
          </div>

          <div
            className="col-md-6 col-xl-4 fade-anim"
            data-delay="0.30"
            data-direction="left"
          >
            <div className="destination-box style-2">
              <div className="destination-thumb">
                <img
                  src="/images/2.jpg"
                  alt="Pune to Mumbai"
                  className="w-100"
                />
              </div>
              <div className="destination-content">
                <div className="info">
                  <h4 className="text-white text-capitalize">
                    <a href="#">Pune to Mumbai</a>
                  </h4>
                  <span className="text-theme-color d-block">Daily Cab Service</span>
                </div>
                <a href="#" className="icon bg-theme-color text-white-color">
                  <i className="fa-solid fa-location-dot"></i>
                </a>
              </div>
            </div>
          </div>

          <div
            className="col-md-6 col-xl-4 fade-anim"
            data-delay="0.60"
            data-direction="left"
          >
            <div className="destination-box style-2">
              <div className="destination-thumb">
                <img
                  src="/images/3.jpg"
                  alt="Pune to Lonavala"
                  className="w-100"
                />
              </div>
              <div className="destination-content">
                <div className="info">
                  <h4 className="text-white text-capitalize">
                    <a href="#">Pune to Lonavala</a>
                  </h4>
                  <span className="text-theme-color d-block">Weekend Rides</span>
                </div>
                <a href="#" className="icon bg-theme-color text-white-color">
                  <i className="fa-solid fa-location-dot"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="text-center mt-50 fade-anim d-none">
              <a href="/destinations" className="vs-btn style4">
                {/* <span>View More</span> */}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DestinationSection;
